var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHome3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "114px",
    height: "116px",
    viewBox: "0 0 114 116",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-home-3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prototype",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing",
    transform: "translate(-953.000000, -829.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3-column",
    transform: "translate(220.000000, 688.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-copy-2",
    transform: "translate(640.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-home-3",
    transform: "translate(93.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 7.345,
    y1: 112.822,
    x2: 99,
    y2: 112.822,
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.452,
    y1: 112.822,
    x2: 107.785,
    y2: 112.822,
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.334,
    y1: 112.822,
    x2: 114,
    y2: 112.822,
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.834,
    y1: 112.822,
    x2: 4.5,
    y2: 112.822,
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.714,74.854 C23.544,74.854 20.973,72.284 20.973,69.114 L20.973,18.516 C9.056,24.551 0.882,36.905 0.882,51.176 C0.882,71.386 17.266,87.771 37.477,87.771 C48.655,87.771 58.656,82.754 65.368,74.855 L26.714,74.855 L26.714,74.854 Z",
    id: "Shape",
    fill: "#E9EAEB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.98,74.854 L26.714,74.854 C23.544,74.854 20.973,72.284 20.973,69.114 L20.973,5.97 C20.973,2.8 23.543,0.229 26.714,0.229 L74.072,0.229 C77.242,0.229 79.812,2.799 79.812,5.97 L79.812,43.282",
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2,
    points: "48.24 63.374 26.714 63.374 26.714 11.71 74.072 11.71 74.072 43.282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.248,50.458 L78.378,50.458 C78.378,48.844 76.853,47.588 75.508,47.588 L72.638,47.588 C72.088,46.726 70.671,46.152 69.767,46.152 L66.897,46.152 L66.897,36.107 C66.897,34.522 65.612,33.237 64.027,33.237 C62.442,33.237 61.157,34.522 61.157,36.107 L61.157,57.634 L59.24,59.474 L55.49,53.661 C53.191,50.498 49.677,52.273 49.677,53.661 C49.677,53.661 54.031,67.554 54.655,68.529 C55.657,70.099 59.723,73.628 59.723,74.855 C59.723,76.084 59.723,80.596 59.723,80.596 L81.249,80.596 C81.249,80.596 81.249,78.223 81.249,76.29 C81.249,74.355 84.119,72.019 84.119,69.114 L84.119,53.328 C84.118,51.714 82.594,50.458 81.248,50.458 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.722,80.596 C59.722,80.596 59.722,76.083 59.722,74.855 C59.722,73.627 55.656,70.099 54.654,68.529 C54.031,67.553 49.676,53.661 49.676,53.661 C49.676,52.273 53.191,50.498 55.489,53.661 L59.239,59.474 L61.156,57.634 L61.156,36.107 C61.156,34.522 62.441,33.237 64.026,33.237 L64.026,33.237 C65.611,33.237 66.896,34.522 66.896,36.107 L66.896,54.764 L66.896,53.328 L66.896,46.152 L69.766,46.152 C70.67,46.152 72.087,46.725 72.637,47.588 L75.507,47.588 C76.852,47.588 78.377,48.844 78.377,50.458 L81.247,50.458 C82.593,50.458 84.117,51.714 84.117,53.328 L84.117,69.114 C84.117,72.018 81.247,74.355 81.247,76.29 C81.247,78.223 81.247,80.596 81.247,80.596",
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.638,
    y1: 47.588,
    x2: 72.638,
    y2: 54.764,
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.378,
    y1: 50.458,
    x2: 78.378,
    y2: 56.198,
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#C1F6FD",
    fillRule: "nonzero",
    x: 56.852,
    y: 79.16,
    width: 27.267,
    height: 16.176
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2,
    points: "84.118 95.336 84.118 79.16 56.852 79.16 56.852 95.336"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.37,
    y1: 5.97,
    x2: 56.852,
    y2: 5.97,
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "49.705 31.802 32.484 31.802 32.454 17.451 49.676 17.451"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.98,
    y1: 20.321,
    x2: 69.767,
    y2: 20.321,
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.98,
    y1: 26.061,
    x2: 65.462,
    y2: 26.061,
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.019,
    y1: 37.542,
    x2: 51.11,
    y2: 37.542,
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.019,
    y1: 43.282,
    x2: 51.11,
    y2: 43.282,
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.019,
    y1: 49.022,
    x2: 42.5,
    y2: 49.022,
    id: "Shape",
    stroke: "#2A5082",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.666,10.833 L47.016,10.833 C46.079,9 43.872,7.111 41.299,7.111 C40.483,7.111 39.705,7.304 38.991,7.591 C37.557,3.769 33.881,0.902 29.559,0.902 C23.998,0.902 19.49,7.168 19.479,10.834 L4.675,10.834",
    id: "Shape",
    stroke: "#BCC0C4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.839,
    y1: 25.498,
    x2: 1.008,
    y2: 25.498,
    id: "Shape",
    stroke: "#BCC0C4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.505,
    y1: 25.498,
    x2: 21.173,
    y2: 25.498,
    id: "Shape",
    stroke: "#BCC0C4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.333,
    y1: 10.833,
    x2: 66.998,
    y2: 10.833,
    id: "Shape",
    stroke: "#BCC0C4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.665,
    y1: 10.833,
    x2: 74.331,
    y2: 10.833,
    id: "Shape",
    stroke: "#BCC0C4",
    strokeWidth: 2
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome3);
export default __webpack_public_path__ + "static/media/icon-home-3.70fdf1bce7dc7cfe690bc9495ce64c45.svg";
export { ForwardRef as ReactComponent };